import { chosenSites } from "app/common/services/chosenSites";
import type { IChosenItemParams } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";
import { allTrackers } from "app/services/track/track";
import { safeJsonParse } from "app/UtilitiesAndConstants/UtilityFunctions/safeJsonParse";
import type { IWebsitePageResult } from "pro-features/components/AutocompleteWebsites/types";
import { getUrlComponents } from "pro-features/components/AutocompleteWebsites/urlComponentUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { WebsitePageResults } from "./types";

export const getPrimarySite = (pageFilter: string) => {
    const { url, searchType }: IChosenItemParams[number] = safeJsonParse(pageFilter)?.[0] as IChosenItemParams[number];
    const { domain } = getUrlComponents(url);
    const icon = ((chosenSites.listInfo as object)[domain] as { icon: string })?.icon;

    return {
        url,
        domain,
        searchType,
        icon,
    };
};

export const updateUrlWithCompetitors = (competitors?: WebsitePageResults) => {
    void proNavigator.updateQueryParams(
        {
            competitorsFilter: JSON.stringify(competitors.map((c) => ({ url: c.name, searchType: c.searchType }))),
        },
        { reload: false },
    );
};

export const getUpdatedCompetitorsOnAddCompetitor = (
    currentCompetitors: WebsitePageResults,
    competitorToAdd: IWebsitePageResult,
    activeCompetitorIndex: number,
): WebsitePageResults => {
    const before = currentCompetitors.slice(0, activeCompetitorIndex);
    const after = currentCompetitors.slice(activeCompetitorIndex + 1);
    return [...before, competitorToAdd, ...after];
};

const trackInlineQueryBarEvents = (action: string, subEvent?: string) => {
    allTrackers.dispatchTrackEvent("Compare", action, `Competitor Opportunities${subEvent ? `/${subEvent}` : ""}`);
};

export const trackAutocompleteOpen = () => {
    trackInlineQueryBarEvents("Open");
};

export const trackAutocompleteSelectSite = (site: string) => {
    trackInlineQueryBarEvents("click", site);
};
